import logo from '@amo/core/assets/images/logos/april.svg';
import './maintenance.scss';

const Maintenance = ({ logoSrc = logo, logoAlt = 'APRIL Moto' }) => {
    const handleRetry = () => {
        window.location.href = '/';
    };

    return (
        <main className={'maintenance-page d-flex align-items-center justify-content-center text-center'}>
            <div className={'maintenance-content'}>
                <img
                    alt={logoAlt}
                    className={'maintenance-logo'}
                    src={logoSrc}
                />
                <h1 className={'maintenance-title'}>
                    Notre formulaire est momentanément indisponible
                </h1>
                <p className={'maintenance-text'}>
                    Notre formulaire de souscription est momentanément à l’arrêt le temps d’une révision.
                </p>
                <p className={'maintenance-text'}>
                    La souscription en ligne sera de nouveau accessible très prochainement.
                </p>
                <button
                    type={'button'}
                    onClick={handleRetry}
                    className={'btn btn-primary medium-rounded maintenance-retry'}
                >
                    Je réessaie
                </button>
            </div>
        </main>
    );
};

export default Maintenance;
export { Maintenance };
